import { Auth } from './utilities/auth.ts';
import { initialiseApi } from './application/api.ts';

window.addEventListener('DOMContentLoaded', async () => {
  if (import.meta.env.MODE === 'development' && !window.Cypress) {
    const { worker } = await import('./mocks/browser');
    worker.start();
  }

  Auth.login()
    .then(async () => {
      try {
        await initialiseApi();
        await import('./application/components/app-switcher/app-switcher.element.ts');
        await import('./application/views/chat-interface/chat-interface.element.ts');
      } catch (error) {
        console.error('App initialization failed:', error);
      }
    })
    .catch((error) => {
      console.error('Login failed:', error);
    });
});
